import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

type CatalogContextType = {
  isListView: boolean;
  setIsListView: Dispatch<SetStateAction<boolean>>;
  searchTerm?: string;
  setSearchTerm?: Dispatch<SetStateAction<string>>;
};

export const CatalogContext = createContext<CatalogContextType | undefined>(
  undefined,
);

export const CatalogContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isListView, setIsListView] = useState(false); // Keep cards view as default
  const [searchTerm, setSearchTerm] = useState<string>('');

  const value: CatalogContextType = useMemo(
    () => ({
      isListView,
      searchTerm,
      setIsListView,
      setSearchTerm,
    }),
    [isListView, searchTerm],
  );

  return (
    <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>
  );
};

export const useCatalogContext = () => {
  const context = useContext(CatalogContext);
  if (!context) {
    throw new Error(
      'useCatalogContext must be used within a CatalogContextProvider',
    );
  }
  return context;
};
